/** Конфиг вьюера (не бренд — бренд в @app/brand). */

/** Демо-площадка для корня сайта, пока нет лендинга. */
export const DEFAULT_VENUE_ID = 'ee-tln-demo-logipark'

/** Откуда берётся карта площадки (в проде — nginx-статика с ETag). */
export const venueDataUrl = (venueId: string): string => `/venues/${venueId}.venue.json`

// Чипы быстрых целей теперь живут в пресетах площадок — @app/rvf resolvePreset
// (ADR 0007). Здесь только конфиг вьюера, не зависящий от типа площадки.
